var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductStarUnrating(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0264 0.958922C10.1797 0.505983 10.8203 0.505985 10.9736 0.958921L12.6029 5.77269C12.809 6.38184 13.3806 6.7918 14.0237 6.7918H19.2065C19.6957 6.7918 19.8938 7.42198 19.4925 7.7019L15.3707 10.5768C14.8234 10.9585 14.5941 11.6559 14.808 12.2879L16.3988 16.988C16.5535 17.4451 16.0349 17.8345 15.6391 17.5584L11.3581 14.5725C10.8425 14.2129 10.1575 14.2129 9.64189 14.5725L5.36085 17.5584C4.96506 17.8345 4.4465 17.4451 4.60121 16.988L6.19199 12.2879C6.40592 11.6559 6.17659 10.9585 5.62928 10.5768L1.50751 7.70189C1.1062 7.42199 1.30426 6.7918 1.79355 6.7918H6.97631C7.61941 6.7918 8.19096 6.38184 8.39713 5.77269L10.0264 0.958922Z",
    fill: "white",
    stroke: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductStarUnrating);
export default __webpack_public_path__ + "static/media/product_star_unrating.448dfe26d86e3e60d4527d3fe9330d1b.svg";
export { ForwardRef as ReactComponent };